import React, { Suspense, lazy } from 'react';
import type { ApexOptions } from 'apexcharts';
import { bhChartBaseOptions } from '../../../styles/design-system/admin-charts';
import { cn } from '../utils';
import { Spinner } from '../Spinner';

const ApexChart = lazy(() => import('react-apexcharts'));

type ChartSeries = ApexOptions['series'];

export interface BhChartProps {
  type: NonNullable<ApexOptions['chart']>['type'];
  series: ChartSeries;
  options?: ApexOptions;
  height?: number | string;
  width?: number | string;
  className?: string;
}

export function BhChart({
  type,
  series,
  options = {},
  height = 320,
  width = '100%',
  className,
}: BhChartProps) {
  const mergedOptions = bhChartBaseOptions({
    ...options,
    chart: {
      type,
      ...(options.chart || {}),
    },
  });

  return (
    <div className={cn('bh-chart', className)}>
      <Suspense
        fallback={
          <div className="bh-chart__fallback" aria-busy="true">
            <Spinner label="Loading chart" />
          </div>
        }
      >
        <ApexChart
          type={type}
          series={series}
          options={mergedOptions}
          height={height}
          width={width}
        />
      </Suspense>
    </div>
  );
}
